export default {
  common: {
    report: 'تقرير',
    poweredBy: 'عن طريق',
    currencyIs: 'العملة هي',
  },
};
